import React from 'react';
import _ from 'lodash';
import { getNavConfig } from 'utils/consts';
import { useFirebaseAuth } from 'contexts/FirebaseAuth';
import { useMemo, useCallback } from 'react';
import { useRouter } from 'next/router';

const useNavConfig = (voucherQuantity) => {
  const router = useRouter();
  const { signOut } = useFirebaseAuth();

  const wrappedSignOut = useCallback(async () => {
    if (typeof window !== 'undefined') {
      await signOut();
      if (window.location.pathname === '/') {
        window.location.reload();
      } else {
        window.location.href = '/';
      }
    }
  }, [signOut]);

  return useMemo(() => {
    return getNavConfig(router, wrappedSignOut).map((section) =>
      section.map((item) => ({
        ...item,
        ...(item.path === '/profile/voucher' && { quantity: voucherQuantity }),
      }))
    );
  }, [router, wrappedSignOut, voucherQuantity]);
};

export default useNavConfig;
